import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

const API_BASE_LOCAL = 'http://127.0.0.1:8000/api/';
const API_BASE_PRODUCTION = '/api/';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiBaseUrl = environment.production ? API_BASE_PRODUCTION : API_BASE_LOCAL;
    const clonedReq = req.clone({url: apiBaseUrl + req.url});
    return next.handle(clonedReq);
  }
}
